if (!customElements.get('loruvio-cart-sticky')) {
  customElements.define('loruvio-cart-sticky', class extends HTMLElement {
    connectedCallback() {
      this.section = document.getElementById('shopify-section-' + this.dataset.sectionId);
      this.refresh = () => {
        this.style.bottom = document.getElementById('PBarNextFrame') ? '72px' : '0px';
        const form = this.section?.querySelector('form[data-type="loruvio-native-product-form"]');
        const main = form?.querySelector('.lv-cart-button');
        const button = this.querySelector('button');
        if (!form || !main || !button) { this.hidden = true; return; }
        button.setAttribute('form', form.getAttribute('id'));
        if (button.disabled !== main.disabled) button.disabled = main.disabled;
        const label = main.textContent.trim();
        if (button.textContent !== label) button.textContent = label;
        this.hidden = main.getBoundingClientRect().bottom >= 0 || main.disabled;
      };
      this.observer = new MutationObserver(this.refresh);
      if (this.section) this.observer.observe(this.section, {subtree:true, childList:true, attributes:true, attributeFilter:['disabled']});
      document.addEventListener('scroll', this.refresh, {passive:true, capture:true});
      window.addEventListener('resize', this.refresh);
      this.refresh();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('scroll', this.refresh, true);
      window.removeEventListener('resize', this.refresh);
    }
  });
}